import React from 'react';

export const LoadingState = () => (
  <div className="loading-state">
    <div className="skeleton-loader">
      <div className="skeleton-title"></div>
      <div className="skeleton-text"></div>
      <div className="skeleton-text"></div>
      <div className="skeleton-text short"></div>
    </div>
  </div>
);

export const PageLoadingSkeleton = () => (
  <div className="page-skeleton">
    <div className="skeleton-header"></div>
    <div className="skeleton-content">
      <div className="skeleton-section">
        <div className="skeleton-title"></div>
        <div className="skeleton-text"></div>
        <div className="skeleton-text"></div>
      </div>
      <div className="skeleton-section">
        <div className="skeleton-title"></div>
        <div className="skeleton-text"></div>
        <div className="skeleton-text short"></div>
      </div>
    </div>
  </div>
);

export const ErrorState = ({ message }) => (
  <div className="error-state">
    <h2>Error Loading Content</h2>
    <p>{message}</p>
    <button onClick={() => window.location.reload()}>Try Again</button>
  </div>
); 